/* Trauungs-Set-Builder
 * Summiert gewählte Teile, zeigt ab 3 Teilen den 10%-Set-Rabatt und legt
 * alles mit gemeinsamen Personalisierungs-Properties in den Warenkorb.
 */
(function () {
  'use strict';

  var RABATT_AB = 3;
  var RABATT_FAKTOR = 0.9;

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function init(root) {
    if (root.dataset.setInit) return;
    root.dataset.setInit = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-set-item]'));
    var totalEl = root.querySelector('[data-set-total]');
    var totalRegularEl = root.querySelector('[data-set-total-regular]');
    var savingsEl = root.querySelector('[data-set-savings]');
    var submitBtn = root.querySelector('[data-set-submit]');
    var errorEl = root.querySelector('[data-set-error]');

    function itemState(item) {
      var include = item.querySelector('[data-set-include]').checked;
      var variantEl = item.querySelector('[data-set-variant]');
      var price, variantId;
      if (variantEl.tagName === 'SELECT') {
        var opt = variantEl.options[variantEl.selectedIndex];
        price = parseInt(opt.dataset.price, 10);
        variantId = parseInt(opt.value, 10);
      } else {
        price = parseInt(variantEl.dataset.price, 10);
        variantId = parseInt(variantEl.value, 10);
      }
      return { include: include, price: price, variantId: variantId };
    }

    function update() {
      var sum = 0;
      var count = 0;
      items.forEach(function (item) {
        var s = itemState(item);
        item.classList.toggle('is-excluded', !s.include);
        var priceEl = item.querySelector('[data-set-price]');
        if (priceEl) priceEl.textContent = euro(s.price);
        if (s.include) {
          sum += s.price;
          count++;
        }
      });

      var rabatt = count >= RABATT_AB;
      totalEl.textContent = euro(rabatt ? Math.round(sum * RABATT_FAKTOR) : sum);
      totalRegularEl.hidden = !rabatt;
      savingsEl.hidden = !rabatt;
      if (rabatt) {
        totalRegularEl.textContent = euro(sum);
        savingsEl.textContent = 'Ihr spart ' + euro(Math.round(sum * (1 - RABATT_FAKTOR))) + ' Set-Rabatt';
      }
      submitBtn.disabled = count === 0;
    }

    function addToCart() {
      var namen = root.querySelector('[data-set-namen]').value.trim();
      var datum = root.querySelector('[data-set-datum]').value.trim();
      var schrift = root.querySelector('[data-set-schrift]').value;

      var properties = {};
      if (namen) properties['Namen'] = namen;
      if (datum) properties['Datum oder Koordinaten'] = datum;
      if (namen || datum) properties['Schriftart'] = schrift;

      var lines = [];
      items.forEach(function (item) {
        var s = itemState(item);
        if (s.include) lines.push({ id: s.variantId, quantity: 1, properties: properties });
      });
      if (!lines.length) return;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird hinzugefügt …';
      errorEl.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          window.location.href = '/cart';
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Set in den Warenkorb';
          errorEl.textContent = 'Das hat leider nicht geklappt – bitte versucht es noch einmal.';
          errorEl.hidden = false;
        });
    }

    root.addEventListener('change', update);
    submitBtn.addEventListener('click', addToCart);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-set-builder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
